import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery'
import { dateToString } from '../Util/dateToString';
/* if you will adjust datepicker settings ->
	read the docs and eat your vegestables bro !
https://bootstrap-datepicker.readthedocs.org/en/latest/options.html*/
require('bootstrap-datepicker')
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.da.js')

export default class DatepickerSmall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date : null
    }
  }
	componentDidMount() {
		this.$i = $(this.refs.datepicker);
    this.$i.datepicker({
      autoclose: true,
      language: 'da-DA',
      calendarWeeks: true,
      todayHighlight: true,
      todayBtn: 'linked',
      weekStart: '1'
    }).on('changeDate', this.onDatepickerChange);
    let initDate = this.props.defaultValue ? this.props.defaultValue : new Date();
    this.$i.datepicker('update', initDate);
    this.props.onChange(initDate);
    this.setState({
      date: initDate
    });
	}
	componentWillUnmount = () => {
		this.$i.datepicker('remove');
	};
	onDatepickerChange = (evt) => {
		this.props.onChange(evt.date);
    this.setState({
      date: evt.date
    });
	};
	render() {
		return (
      <div>
          <div style={styles.date} onClick={()=>this.$i.datepicker('show')}> {this.state.date ? dateToString(this.state.date) : null} </div>
          <i ref="datepicker" style={styles.i} className="fa fa-calendar"></i>
      </div>
		);
	}
}

var styles = {
  date: {
    float: 'left',
    fontSize: '18px',
    cursor: 'pointer'
  },
  i : {
    float: 'right',
    fontSize:'18px',
    marginLeft: '10px',
    lineHeight: 'inherit',
    cursor: 'pointer'
  }
}

	DatepickerSmall.propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.instanceOf(Date)
  };



// WEBPACK FOOTER //
// ./src/App/Common/datepickerSmall.jsx